import { render, staticRenderFns } from "./SwitchWithEditor.vue?vue&type=template&id=986d8496&"
import script from "./SwitchWithEditor.vue?vue&type=script&lang=js&"
export * from "./SwitchWithEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports